// extracted by mini-css-extract-plugin
export default {"sharedAccountCard":"style_sharedAccountCard__ye3FO","groupItemIcon":"style_groupItemIcon__jFzy0"};